import { render, staticRenderFns } from "./OwnerCreationPreRegistration.vue?vue&type=template&id=7abe9c5c&scoped=true&"
import script from "./OwnerCreationPreRegistration.vue?vue&type=script&lang=js&"
export * from "./OwnerCreationPreRegistration.vue?vue&type=script&lang=js&"
import style0 from "./OwnerCreationPreRegistration.vue?vue&type=style&index=0&id=7abe9c5c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7abe9c5c",
  null
  
)

export default component.exports